interface TwitchPlayerProps {
    channel: string;
    autoplay?: boolean;
    muted?: boolean;
    className?: string;
    layout?: "video" | "video-with-chat";
}

export default function TwitchPlayer({
    channel,
    autoplay = false,
    muted = false,
    className = "",
    layout = "video",
}: TwitchPlayerProps) {
    const parent = window.location.hostname;

    if (layout === "video-with-chat") {
        // Render video player and chat side by side
        return (
            <div key={channel} className={`flex gap-0 ${className}`}>
                <iframe
                    src={`https://player.twitch.tv/?channel=${channel}&parent=${parent}&autoplay=${autoplay}&muted=${muted}`}
                    className="flex-1"
                    allowFullScreen
                    scrolling="no"
                    style={{ border: "none" }}
                />
                <iframe
                    src={`https://www.twitch.tv/embed/${channel}/chat?parent=${parent}`}
                    className="w-87.5"
                    style={{ border: "none" }}
                />
            </div>
        );
    }

    // Video only
    return (
        <iframe
            key={channel}
            src={`https://player.twitch.tv/?channel=${channel}&parent=${parent}&autoplay=${autoplay}&muted=${muted}`}
            className={className}
            allowFullScreen
            scrolling="no"
            style={{ border: "none" }}
        />
    );
}
